module.exports = __webpack_public_path__ + "img/service-duanxin1.dbf970dd.svg";